import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["colspan"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("td", {
        colspan: _ctx.colspan,
        class: "text-center py-4"
    }, [
        _createElementVNode("span", {
            class: _normalizeClass(["fw-normal", _ctx.textClass])
        }, _toDisplayString(_ctx.message), 3),
        _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1));
}
